import { render, staticRenderFns } from "./Uploadfileitem.vue?vue&type=template&id=b55cf8c4&scoped=true"
import script from "./Uploadfileitem.vue?vue&type=script&lang=js"
export * from "./Uploadfileitem.vue?vue&type=script&lang=js"
import style0 from "./Uploadfileitem.vue?vue&type=style&index=0&id=b55cf8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b55cf8c4",
  null
  
)

export default component.exports